import { Group, Typography, Wrapper } from '@screentone/core';

import ContentParametersDisplay from './ContentParametersDisplay';

interface Parameter {
  type: string;
  name: string;
  value?: unknown;
}

interface ParametersDisplayProps {
  parameters: Parameter[];
  title?: string;
  skipQuery?: boolean;
}

const ParametersDisplay = ({ parameters, title, skipQuery = true }: ParametersDisplayProps) => {
  if (!Array.isArray(parameters) || parameters.length === 0) return null;

  return (
    <Wrapper margin={{ vertical: 'md' }}>
      <details>
        <summary>
          {title && (
            <Typography variant="header4" inline>
              {title}
            </Typography>
          )}
        </summary>
        <Group direction="column" gap="xs" fullWidth>
          {parameters.map((param, idx) => {
            // Skip displaying query as a parameter since it's shown separately
            if (skipQuery && param.name === 'query') return null;

            // Special handling for content_parameters
            if (param.name === 'content_parameters' && typeof param.value === 'object' && param.value !== null) {
              return <ContentParametersDisplay key={idx} value={param.value as Record<string, unknown>} />;
            }

            // Format the value based on its type
            let formattedValue: string;
            if (param.value === undefined) {
              formattedValue = '(not set)';
            } else if (typeof param.value === 'object' && param.value !== null) {
              formattedValue = JSON.stringify(param.value);
            } else if (typeof param.value === 'boolean') {
              formattedValue = param.value ? 'true' : 'false';
            } else if (param.value === null) {
              formattedValue = '';
            } else {
              formattedValue = String(param.value);
            }

            return (
              <Typography key={idx} size="sm">
                <strong>{param.name}:</strong> {formattedValue}
              </Typography>
            );
          })}
        </Group>
      </details>
    </Wrapper>
  );
};

export default ParametersDisplay;
